import { FormHelperText, MenuItem, Select } from '@material-ui/core'

import * as R from 'ramda'
import React, { FC } from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

interface FormSingleSelectInputInterface {
  fieldName: string
  selections: string[]
  defaultValue?: string
  rules?: any
  required?: boolean
  disable?: boolean
  noSort?: boolean
}

const FormSingleSelector: FC<FormSingleSelectInputInterface> = ({
  fieldName,
  selections,
  defaultValue,
  rules = {},
  required = false,
  disable = false,
  noSort = false
}: FormSingleSelectInputInterface) => {
  const { control, setValue } = useFormContext()
  const value = useWatch({ control, name: fieldName }) ?? defaultValue

  return (
    <Controller
      control={control}
      name={fieldName}
      value={value}
      defaultValue={defaultValue}
      rules={{ ...rules, required }}
      as={
        <>
          <Select
            id={`${fieldName}-select`}
            fullWidth
            value={value}
            defaultValue={defaultValue}
            disabled={disable}
            onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
              const selectedValue = event.target.value
              setValue(fieldName, selectedValue)
            }}
          >
            {!required && (
              <MenuItem key="empty-item" value="">
                <em>None</em>
              </MenuItem>
            )}
            {(noSort
              ? selections
              : R.sortBy(R.compose(R.toLower), selections)
            ).map((item) => (
              <MenuItem key={`${fieldName}-${item}`} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
          {required && <FormHelperText>Required</FormHelperText>}
        </>
      }
    />
  )
}

export default FormSingleSelector
